module.exports = __webpack_public_path__ + "static/media/twitter.7c65ec17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/twitter.svg
// module id = 106
// module chunks = 0